"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdpartInjectConnector = void 0;
const InjectConnector_1 = require("./InjectConnector");
const protocol_1 = require("../protocol");
const iconnector_1 = require("./iconnector");
const utils_1 = require("../utils");
class ThirdpartInjectConnector extends InjectConnector_1.InjectConnector {
    getType() {
        if (this.walletName === protocol_1.AptosGoogleWalletName) {
            return iconnector_1.CONNECTOR_TYPE.KEYLESS.GOOGLE_WALLET;
        }
        else if (this.walletName === protocol_1.AptosAppleWalletName) {
            return iconnector_1.CONNECTOR_TYPE.KEYLESS.APPLE_WALLET;
        }
        else {
            return iconnector_1.CONNECTOR_TYPE.INJECT.STANDARD_INJECT_WALLET;
        }
    }
    constructor(thirdpartInjectWallet) {
        super();
        this.walletName = thirdpartInjectWallet.walletName;
        thirdpartInjectWallet.wallets.forEach((value, key) => {
            this.providerMap.set(key, value);
        });
        this.icon = thirdpartInjectWallet.icon;
    }
    registerWallet(nameSpace, wallet) {
        this.providerMap.set(nameSpace, wallet);
    }
    getTag() {
        var _a;
        return iconnector_1.STANDARD_INJECT_WALLET + ((_a = this.walletName) !== null && _a !== void 0 ? _a : "");
    }
    getWalletVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            const firstWallet = this.providerMap.values().next().value;
            if (!firstWallet) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
            }
            return firstWallet.getVersion();
        });
    }
    openWallet(engineConnectInfo, openAppLinkType) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            (0, utils_1.logDebug)("InjectEngine connect begin:", JSON.stringify(engineConnectInfo));
            if (!engineConnectInfo) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR);
            }
            this.dappInfo = engineConnectInfo.connectRequest.dAppInfo;
            var universalConnectRequest = engineConnectInfo.connectRequest;
            try {
                if (universalConnectRequest.requests) {
                    let requestAccounts = universalConnectRequest.requests
                        .find(item => item.name === "requestAccounts");
                    const required = (_a = requestAccounts.requiredNamespaces) !== null && _a !== void 0 ? _a : [];
                    const optional = (_b = requestAccounts.optionalNamespaces) !== null && _b !== void 0 ? _b : [];
                    let result = undefined;
                    if (required.length + optional.length === 1) {
                        const singleItem = required.length === 1 ? required[0] : optional[0];
                        const singleProvider = this.providerMap.get(singleItem.namespace);
                        this.addListener(singleItem.namespace);
                        // await this.disconnect()
                        if (singleProvider) {
                            result = yield this.getResponseByConnect(singleProvider);
                        }
                        else {
                            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "openWallet: provider not found");
                        }
                    }
                    if (this.connectResultListener && result) {
                        this.connectResultListener(result, this);
                    }
                }
            }
            catch (error) {
                var code = protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR;
                var message = '';
                if (error instanceof protocol_1.OKXConnectError) {
                    code = error.code;
                    message = error.message;
                }
                if (this.connectResultListener) {
                    this.connectResultListener({
                        requestId: "-1",
                        method: 'connect_error',
                        payload: {
                            code: code
                        }
                    });
                }
            }
        });
    }
    getResponseByConnect(provider) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let result = {
                method: "connect",
                requestId: Date.now().toString(),
                payload: {
                    wallet: {
                        platform: (_a = navigator.platform) !== null && _a !== void 0 ? _a : "/",
                        appName: iconnector_1.STANDARD_INJECT_WALLET + this.walletName,
                        appVersion: (_b = this.getWalletVersion()) !== null && _b !== void 0 ? _b : "1.0.0",
                        maxProtocolVersion: 1,
                    },
                    responses: []
                },
            };
            let responseItem = {
                name: "requestAccounts",
                accounts: [],
            };
            result.payload.responses.push(responseItem);
            responseItem.accounts.push(yield this.getAccount(provider));
            return result;
        });
    }
    getAccount(provider) {
        return __awaiter(this, void 0, void 0, function* () {
            return provider.getAccount();
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([...this.providerMap.values()].map(provider => provider.disconnect()));
        });
    }
    onDisconnect() {
        this.disconnectListener.forEach(listener => listener());
        this.disconnectListener = [];
    }
    restoreconnect(sessionInfo, onConnectResult) {
        const keys = Object.keys(sessionInfo.namespaces);
        const isSingleChain = keys.length === 1;
        if (!isSingleChain) {
            onConnectResult(null);
            return;
        }
        const provider = this.getInjectProvider(keys[0]);
        if (!provider)
            return onConnectResult(null);
        provider.getAccount().then(account => {
            var _a;
            let address = (_a = account === null || account === void 0 ? void 0 : account.addresses) !== null && _a !== void 0 ? _a : [""];
            if (sessionInfo.namespaces[keys[0]].accounts[0].includes(address[0])) {
                onConnectResult(sessionInfo);
            }
            else {
                onConnectResult(null);
            }
        }).catch(error => {
            onConnectResult(null);
        });
    }
    checkAccountChanged(nameSpace, newAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                let sessionLocal = (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getSessionContent('connectSession');
                if (newAddress) {
                    if (sessionLocal.namespaces[nameSpace].accounts.includes(newAddress)) {
                        return;
                    }
                }
                let provider = this.getInjectProvider(nameSpace);
                if (provider) {
                    let sessionNew = yield this.getResponseByConnect(provider);
                    if (!!sessionNew && sessionLocal) {
                        let universalResponses = sessionNew.payload.responses;
                        let universalAccountItem = universalResponses[0].accounts[0];
                        sessionLocal.namespaces[nameSpace].accounts = universalAccountItem.addresses;
                        sessionLocal.namespaces[nameSpace].extra = universalAccountItem.extra;
                        sessionLocal.namespaces[nameSpace].rpcMap = undefined;
                        sessionLocal.namespaces[nameSpace].methods = universalAccountItem.methods;
                        (_b = this.accountChangeListener) === null || _b === void 0 ? void 0 : _b.call(this, sessionLocal);
                    }
                }
            }
            catch (error) {
                yield this.disconnect();
            }
        });
    }
    addListener(nameSpace) {
        var _a, _b;
        for (let providerMapKey in this.providerMap) {
            (_a = this.providerMap.get(providerMapKey)) === null || _a === void 0 ? void 0 : _a.removeListener();
        }
        (_b = this.getInjectProvider(nameSpace)) === null || _b === void 0 ? void 0 : _b.addAccountChangedListener((newAddress) => {
            if (newAddress) {
                this.checkAccountChanged(nameSpace, newAddress).catch(e => {
                });
            }
            else {
                this.onDisconnect();
            }
        });
    }
    supportNamespaceAndChains(nameSpace, chains) {
        let provider = this.providerMap.get(nameSpace);
        if (!provider) {
            return false;
        }
        return provider.supportChains(chains);
    }
}
exports.ThirdpartInjectConnector = ThirdpartInjectConnector;
